import { render, staticRenderFns } from "./GradeStatus.vue?vue&type=template&id=b0b04110&scoped=true&"
import script from "./GradeStatus.vue?vue&type=script&lang=js&"
export * from "./GradeStatus.vue?vue&type=script&lang=js&"
import style0 from "./GradeStatus.vue?vue&type=style&index=0&id=b0b04110&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0b04110",
  null
  
)

export default component.exports